import React,{useEffect,useState} from 'react';
import {Form,Button,Alert,Spinner,Card} from 'react-bootstrap'
import { useFormik } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css';
import './daily.css'
import { useHistory } from "react-router-dom";
import * as yup from 'yup';
import { ExclamationCircle } from 'react-bootstrap-icons';
import Select from 'react-select';

function getUrlParams(name:string) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //定义正则表达式
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}



function CovidDaily() {

    let init0 = {
        project_status: 0,
        return_1: 0,
        return_2: 0,
        return_3: 0,
        return_4: 0,
        return_status: "",
        people_1: 0,
        people_2: 0,
        people_3: 0,
        people_4: 0,
        goods_1: 0,
        goods_2: 0,
        goods_3: 0,
        goods_4: 0,
        goods_5: 0,
        goods_6: 0,
        goods_7: 0,
        goods_8: 0,
        goods_9: 0,
        goods_10: 0,
        goods_11: 0,
        goods_12: 0,
        goods_13: 0,
        suspected: 0,
        remark: "",
        org_id: 0,
        company_id: 0,
        area_country_id: 0,
    }
    const history = useHistory();
    const [url,setUrl] = useState('')
    const [display, setDisplay] = useState(false)
    const [show, setShow] = useState(false)
    const [orgs, setOrgs] = useState([])
    const [countries, setCountries] = useState([])
    const [header,setHeader] = useState({})
    const [last,setLast] = useState(init0)
    const [loading,setLoaing] = useState(true)
    const [initialValues,setInit] = useState(init0)
    const [errorMessage,setErrorMessage] = useState('')
    const [showCountry,setShowCountry] = useState(false)
    const logOut = '登录状态异常，请重新登录APP，如果该问题仍然存在，请联系管理员。'
    const permissionError = '暂无需要上报的机构，如有权限分配问题，请联系管理员。'


    const create = (values:object)=>{
        fetch(url+"tihal/epidemic-daily/create-v3",{method:'POST',headers: header,body:JSON.stringify(values)})
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result)
                    if(result.code === 401){
                        setDisplay(false)
                        setErrorMessage(logOut)
                        setLoaing(false)
                        return true;
                    }
                    if(result.retcode === -1){
                        alert(result.retmsg)
                    }

                    if(result.retcode === 0){
                        history.push('/success')
                    }

                },
                (error) => {
                    console.log(error)
                }
            )
    }

    function preRequest(url:string,header:any){
        fetch(url + "tihal/epidemic-daily/check-permission", { method: 'POST', headers: header })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.code === 401) {
                        setDisplay(false)
                        setErrorMessage(logOut)
                        setLoaing(false)
                        return true;
                    }
                    if (result.resp.permission) {
                        setDisplay(true)
                    } else {
                        setErrorMessage(permissionError)
                        setDisplay(false)
                    }

                    setTimeout(() => {
                        setLoaing(false)
                    }, 500)

                },
                (error) => {
                    console.log(error)
                }
            )

        fetch(url + "tihal/epidemic-daily/orgs", { method: 'POST', headers: header })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.code === 401) {
                        setDisplay(false)
                        setErrorMessage(logOut)
                        setLoaing(false)
                        return true;
                    }
                    setOrgs(result.resp)
                },
                (error) => {
                    console.log(error)
                }
            )

        fetch(url + "/tihal/app-country/get-area-country", { method: 'POST', headers: header })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.code === 401) {
                        setDisplay(false)
                        setErrorMessage(logOut)
                        setLoaing(false)
                        return true;
                    }
                    setCountries(result.resp.list)
                },
                (error) => {
                    console.log(error)
                }
            )

        fetch(url + "tihal/epidemic-daily/last", { method: 'POST', headers: header })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.code === 401) {
                        setDisplay(false)
                        setErrorMessage(logOut)
                        setLoaing(false)
                        return true;
                    }
                    if (!result.resp) {
                        return
                    }
                    setShow(true)
                    setLast(result.resp)

                },
                (error) => {
                    console.log(error)
                }
            )
    }

     useEffect(() => {
        const token = getUrlParams("token")
        const url_param = getUrlParams("url")

        if (!token) {
            setDisplay(false)
            // history.push('/empty')
        }

        setHeader({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        })

         if (url_param && null != url_param) {
             setUrl(url_param)
         }else{
             setUrl('https://crisisresponse.tihal.cn/')
         } 
    }, [])

    useEffect(() => {
        if (url !== '') {
            preRequest(url, header)
        }
    }, [url])

    const getLast = () => {
        setShow(false)
        let a = initialValues
        a.goods_1 = last.goods_1
        a.goods_2 = last.goods_2
        a.goods_3 = last.goods_3
        a.goods_4 = last.goods_4
        a.goods_5 = last.goods_5
        a.goods_6 = last.goods_6
        a.goods_7 = last.goods_7
        a.goods_8 = last.goods_8
        a.goods_9 = last.goods_9
        a.goods_10 = last.goods_10
        a.goods_11 = last.goods_11
        a.goods_12 = last.goods_12
        a.goods_13 = last.goods_13
        a.people_1 = last.people_1
        a.people_2 = last.people_2
        a.people_3 = last.people_3
        a.people_4 = last.people_4
        a.return_1 = last.return_1
        a.return_2 = last.return_2
        a.return_3 = last.return_3
        a.return_4 = last.return_4
        a.return_status = last.return_status
        a.org_id = last.org_id
        a.company_id = last.company_id
        a.area_country_id = 0
        setInit(a)
    }


 
    const schema = yup.object({
        org_id: yup.number().min(1,'请选择机构').required(),
        people_2: yup.number().required(),
        people_3: yup.number().required(),
        people_4: yup.number().required(),
    });

    const formik = useFormik({
        initialValues,
        validationSchema:schema,
        onSubmit: values => {
            console.log(values);
            create(values)
        },
    });

    /**
     * 
     * @param value 临时机构写死ID
     */
   function handleOrgBlur(value:any){
       if(value === 1692){
           setShowCountry(true)
       }else{
           setShowCountry(false)
       }
    }

  
    return loading ? <div className="row align-items-center justify-content-center loading">
        <Spinner animation="grow" variant="primary" />
    </div> :
        !display ? (
            <div className="App">
                <div className="daily">
                    <Card>
                        <Card.Title>
                            <div className="warning"><ExclamationCircle /></div>
                        </Card.Title>
                        <Card.Body>{errorMessage}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        ) : (
            <div className="App">
            <div className="daily">
                <Alert  transition={false}   show={show} variant="success">
                    <p>  是否自动填入上次填报内容？</p>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <Button onClick={()=>{getLast()}} variant="outline-success">是</Button>
                    </div>
                </Alert>
                <Form onSubmit={formik.handleSubmit}>
                    <h4>基础信息</h4>
                            <Form.Group>
                                <Form.Label>境外机构</Form.Label>
                                <Select options={orgs}  getOptionValue={(option: any) => option.id} getOptionLabel={(option: any) => option.name} name="org_id" placeholder="请选择机构" onChange={(option: any) => {
                                        formik.setFieldValue("org_id", option?.id)
                                        handleOrgBlur(option?.id)
                                }} />
                                <Form.Control.Feedback type="invalid">{formik.errors.org_id}</Form.Control.Feedback>
                            </Form.Group>
                            {!showCountry ? null :
                                <Form.Group>
                                    <Form.Label>前往国家（地区）</Form.Label>
                                    <Select options={countries} name="area_country_id" placeholder="请选择前往国家（地区）" onChange={(option: any) => formik.setFieldValue("area_country_id", option?.value)} />
                                </Form.Group>
                            }
                    <Form.Group >
                        <Form.Label>派出在册职工数量</Form.Label>
                        <Form.Control type="number"  name="people_1"  value={formik.values.people_1} onChange={formik.handleChange} />
                    </Form.Group>


                    <Form.Group>
                        <Form.Label>劳务派遣员工数量</Form.Label>
                        <Form.Control type="number" name="people_2"  value={formik.values.people_2} onChange={formik.handleChange} />
                    </Form.Group>


                    <Form.Group >
                        <Form.Label>国内分包商员工数量</Form.Label>
                        <Form.Control type="number" name="people_3"  value={formik.values.people_3} onChange={formik.handleChange}  />
                    </Form.Group>

                    <Form.Group >
                        <Form.Label>外方雇员数量</Form.Label>
                        <Form.Control type="number" name="people_4"  value={formik.values.people_4} onChange={formik.handleChange}  />
                    </Form.Group>

                    <Form.Group >
                        <Form.Label>当日返回 <b>境内</b> 人员数量</Form.Label>
                        <Form.Control type="number"  value={formik.values.return_1} name="return_1" onChange={formik.handleChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>当日返回 <b>项目</b> 人员数量</Form.Label>
                        <Form.Control type="number"  value={formik.values.return_3} name="return_3" onChange={formik.handleChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>本月返回 <b>境内</b> 人员数量</Form.Label>
                        <Form.Control type="number"  value={formik.values.return_2} name="return_2" onChange={formik.handleChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>本月返回 <b>项目</b> 人员数量</Form.Label>
                        <Form.Control type="number"  value={formik.values.return_4} name="return_4" onChange={formik.handleChange} />
                    </Form.Group>
                    <Form.Group >
                        <Form.Label>返回境内人员隔离情况</Form.Label>
                        <Form.Control as="textarea" rows={3} type="text" placeholder="是否按要求进行隔离，是否解除隔离或正处于隔离期" name="return_status" onChange={formik.handleChange}/>
                    </Form.Group>

                    <h4>防疫物资储备数量</h4>
                    <Form.Group >
                        <Form.Label>医用口罩</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_1} name="goods_1" onChange={formik.handleChange} />
                    </Form.Group>

                    <Form.Group >
                        <Form.Label>N95口罩</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_10} name="goods_10" onChange={formik.handleChange} />
                    </Form.Group>

                    <Form.Group >
                        <Form.Label>消毒液（L)</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_2} name="goods_2" onChange={formik.handleChange} />
                    </Form.Group>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>防护服（套）</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_3} name="goods_3" onChange={formik.handleChange} />
                    </Form.Group>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>护目镜（副）</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_4} name="goods_4" onChange={formik.handleChange} />
                    </Form.Group>

                    <h4>防疫药品储备数量</h4>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>连花清瘟（盒）</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_5} name="goods_5" onChange={formik.handleChange} />
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>阿比多尔（盒）</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_6} name="goods_6" onChange={formik.handleChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>是否出现疑似、确诊病例</Form.Label>
                        <Form.Control as="select"  value={formik.values.suspected} name="suspected" onChange={formik.handleChange}>
                            <option value="0" >否</option>
                            <option value="1" >是</option>
                        </Form.Control>
                    </Form.Group>

                    <h4>防疫设备储备数量</h4>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>血氧仪（个）</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_9} name="goods_9" onChange={formik.handleChange} />
                    </Form.Group>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>体温计（个）</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_11} name="goods_11" onChange={formik.handleChange} />
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>呼吸机（个）</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_12} name="goods_12" onChange={formik.handleChange} />
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>制氧机（个）</Form.Label>
                        <Form.Control type="number"  value={formik.values.goods_13} name="goods_13" onChange={formik.handleChange} />
                    </Form.Group>

                    <Button variant="primary"  type="submit">
                        提交
                    </Button>
                </Form>

            </div>
        </div>
    );
}

export default CovidDaily;
